<template>
  <li
    :class="[
      'w-77.5 bg-dustrose text-burgundy p-2.5 shrink-0 cursor-pointer hover:scale-[1.02] transition-transform',
      { 'border-2 border-pink': border },
    ]"
  >
    <div class="h-full grid grid-rows-[auto_1fr] w-full">
      <div class="bg-burgundy overflow-hidden">
        <ResponsiveImage :media="content.image" class="object-cover w-full aspect-4/3" />
      </div>
      <div
        :class="[
          'h-full flex items-center text-center p-5 overflow-hidden border-l border-b border-r border-pink',
        ]"
      >
        <p class="font-title text-sm text-pink uppercase w-full">{{ content.title }}</p>
      </div>
    </div>
  </li>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'

export default {
  name: 'VRLocationCard',
  components: { ResponsiveImage },
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object as PropType<VRLocationCard>,
      required: true,
    },
  },
}
</script>
